import React from "react";

type MoreButtonProps = {
    className?: string;
};

/**
 * 비즈니스 페이지 히어로의 "더 알아보기" 버튼.
 *
 * 브라우저 기본 앵커 이동은 html 의 scroll-behavior: smooth 를 타는데,
 * 움직이는 동안 휠 입력이 들어오면 그 자리에서 멈춰 엉뚱한 곳에 선다.
 * 직접 호출해 항상 같은 지점에 착지시킨다. scroll-mt 는 그대로 존중된다.
 */
const MoreButton = ({ className = "" }: MoreButtonProps) => (
    <a
        href="#1"
        onClick={e => {
            e.preventDefault();
            document
                .getElementById("1")
                ?.scrollIntoView({ block: "start" });
        }}
        className={`inline-block rounded-md border border-transparent bg-brand px-4 py-3 text-center text-caption font-medium text-white hover:bg-brand-light sm:px-5 sm:text-base md:px-8 ${className}`}
    >
        더 알아보기
    </a>
);

export default MoreButton;
